import type { ResultMessageConfirmationWebSocket } from "@/Modules/Chat/Models/WebSocket";
import type { TextChatRoomItem } from "@/Modules/Chat/Models/Domain/Chat";
import type { EventFilter } from "@/Modules/Chat/WebSocketManager";

import { MessageTypeWebSocket } from "@/Modules/Chat/Models/WebSocket";
import { type ChatStore, useChatStore } from "@/Modules/Chat/Store";

import { hasValue, isObject } from "@/Utils/Objects";

import { danger } from "@/Utils/Debug";
import { isValidString } from "@/Utils/String";

const reg = new RegExp("^chat:message:[a-zA-Z0-9]+:[0-9]+$", "i");
export interface ExtraParamsResultEventConfirmation {
  chatStore: ChatStore;
}

export const isResultEventConfirmationMessage = (
  message: unknown
): message is ResultMessageConfirmationWebSocket => {
  return (
    isObject(message) &&
    isValidString(message.nonce) &&
    hasValue(message.type) &&
    hasValue(message.nonce) &&
    message.type === MessageTypeWebSocket.RESULT &&
    reg.test(message.nonce)
  );
};

export const resultEventConfirmationMessageHandler = (
  message: ResultMessageConfirmationWebSocket,
  { chatStore = useChatStore() }: ExtraParamsResultEventConfirmation
): Promise<boolean> => {
  const { nonce, eid } = message;
  const [chatId] = nonce.split(":").splice(2, 1);

  try {
    const messageIndex = chatStore.rooms[chatId].events.findIndex((event) => event.id === nonce);

    if (messageIndex !== -1) {
      chatStore.rooms[chatId].events[messageIndex].id = eid;
      (chatStore.rooms[chatId].events[messageIndex] as TextChatRoomItem).isConfirmed = true;

      return Promise.resolve(true);
    }

    return Promise.resolve(false);
  } catch (e) {
    danger("Invalid message confirmation", nonce, eid);

    return Promise.resolve(false);
  }
};

export default {
  isType: isResultEventConfirmationMessage,
  handler: resultEventConfirmationMessageHandler,
} as EventFilter<ExtraParamsResultEventConfirmation>;
